import { find, flow, partialRight, values } from 'lodash';
import { getAsyncActionTypesDelimiter, availableStatuses } from '@cld/api-middleware';
import { actionCreator } from './actionCreators';

const splitToNameAndStatusRegex = new RegExp(`(.*)[${getAsyncActionTypesDelimiter()}](.*)`);

const apiMiddlewareMapper = (action) => {
  const [actionName, actionStatus] = (splitToNameAndStatusRegex.exec(action.type) || []).slice(1);

  const status =
    actionStatus &&
    flow(
      values,
      partialRight(find, (status) => status === actionStatus)
    )(availableStatuses);

  return actionCreator({ ...action, name: actionName, status, error: action.error });
};

export default apiMiddlewareMapper;
